import styled from 'styled-components';

export const DropdownRow = styled.div`
font-size: 14px;
line-height: 17px;
color: ${p => p.selected ? window?.settings?.primary_color ?? '#1DBD6B' : '#566F75'};
cursor: pointer;
white-space: nowrap;

display: flex;
align-items: center;
padding-left: 20px;
padding-right: 20px;

&:hover {
  color: ${window?.settings?.primary_color ?? '#1DBD6B'};
}
`;
